<template>
  <div>
    <!-- <div
      v-if="!!$config.sms_module_test && last_date"
      class="filter filter--block filter-hint mb-4"
    >
      {{ $t('shared.component.table.last_date') }}{{ last_date }}
    </div> -->
    <filter-wrapper @submit="submit">
      <div class="filter__row">
        <div class="filter__item col-3">
          <label class="filter__item__title">
            {{ $t('mailer.stats.general.filter.group_by.title') }}
          </label>
          <div class="filter__item__body">
            <mailings-stats-filter-input-group v-model="form.group_by" />
          </div>
        </div>
        <div class="filter__item col-3">
          <label class="filter__item__title">
            {{ $t('mailer.stats.general.filter.source.title') }}
          </label>
          <div class="filter__item__body">
            <mailings-input-source v-model="form.source" />
          </div>
        </div>

        <div class="filter__item col-3">
          <label class="filter__item__title">
            {{ $t('mailer.stats.general.filter.sender.title') }}
          </label>
          <div class="filter__item__body">
            <mailings-stats-filter-input-sender v-model="form.sender" />
          </div>
        </div>
      </div>

      <div class="filter__row">
        <div class="filter__item filter__item--datepicker">
          <label class="filter__item__title">
            {{ $t('shared.component.filter.period') }}
          </label>
          <div class="filter__item__body">
            <date-range-picker v-model="form.date" />
          </div>
        </div>

        <div class="filter__item filter__item--button">
          <i-button html-type="submit" type="primary">
            {{ $t('shared.component.filter.show_result') }}
          </i-button>
        </div>
      </div>
    </filter-wrapper>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import { initSearchStateByPeriod, parseSearchStateByPeriod } from '@shared/helpers/date_format';
  import FilterWrapper from '@shared/components/filter-base';
  import MailingsStatsFilterInputGroup from '@mailer/components/stats/archived-mailings-stats-filter-input-group';
  import MailingsStatsFilterInputSender from '@mailer/components/stats/mailings-stats-filter-input-sender';
  import MailingsInputSource from '@mailer/components/mailings/mailings-input-source';
  // import moment from 'moment-es6';

  export default {
    components: {
      MailingsInputSource,
      MailingsStatsFilterInputGroup,
      MailingsStatsFilterInputSender,
      FilterWrapper
    },
    data: () => ({
      // last_date: '',
      form: {
        group_by: 'day',
        source: null,
        sender: '',
        date: initSearchStateByPeriod()
      }
    }),
    created() {
      // const { start, end } = parseSearchStateByPeriod(this.form.date);
      // const { group_by, source, sender } = this.form;

      // const params = {
      //   group_by,
      //   source,
      //   sender,
      //   type: 'all',
      //   date_from: start,
      //   date_to: end
      // };

      // this.getData({
      //   ...params,
      //   sort_direction: 'desc',
      //   sort_column: 'created_at',
      //   items_per_page: 1,
      //   current_page: 1
      // }).then((res) => {
      //   this.last_date = res.data[0]?.created_at;

      //   if (this.last_date) {
      //     let start = moment(this.last_date).subtract(6, 'd').startOf('d');
      //     let end = moment(this.last_date).endOf('d');
      //     this.form.date.start = start;
      //     this.form.date.end = end;

      //     this.search({
      //       ...params,
      //       date_from: start.format('YYYY-MM-DD HH:mm:ss'),
      //       date_to: end.format('YYYY-MM-DD HH:mm:ss')
      //     });
      //   } else {
      this.submit();
      // }
      // });
    },

    methods: {
      ...mapActions('mailer/archived_stats/general', ['search']),
      ...mapActions('mailer/archived_stats/detailed', ['getData']),

      submit: function () {
        const { start, end } = parseSearchStateByPeriod(this.form.date);
        const { group_by, source, sender } = this.form;

        const params = {
          group_by,
          source,
          sender,
          type: 'all',
          date_from: start,
          date_to: end
        };

        this.search(params);
      }
    }
  };
</script>
<style lang="scss">
  .filter__item--datepicker {
    margin-right: 30px;
  }
</style>
